<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Lewa kolumna',
              modelPath: [this, 'form', 'left_column'],
              required: true,
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Prawa kolumna',
              modelPath: [this, 'form', 'right_column'],
              required: true,
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
